module.exports = {
  google: {
    API_KEY: "AIzaSyD10XeOnXnWbf-RCbEw3Lupqnx9T40kLKY",
    CLIENT_ID:
      "787446653713-49tdjl1r1l90mkqbkl4v0v4g730jh9nd.apps.googleusercontent.com",
    // "10196126543-sib8tbc4cve990jukv8m9ql48oumbh3m.apps.googleusercontent.com", // dev lazaros
    SECRET: "D_nkkaW2iGfcL7oyQPILGIfo",
  },
  facebook: {
    APP_ID: "1113734715675973",
  },
  recaptcha: {
    siteKey: "6LetyAgaAAAAAMHa-8P3Rs1KFqA7Chi8YGhQGNM6",
    // 2 chave 6LetyAgaAAAAAJ6Ov7M1jaEt1If5vLnFUF_BYGpQ
  },
  api: {
    url: process.env.REACT_APP_URL || "http://localhost:3000/api/v1/",
  },
  socket: {
    url: process.env.REACT_APP_SOCKET_URL || "http://localhost:3010",
  },
  onesignal: {
    options: {
      // REACT_APP_ONE_SIGNAL_ID permite apontar para outro app da OneSignal sem
      // tocar no código (teste local, staging). Sem a variável, segue o app de
      // produção, que é onde estão os inscritos.
      appId: process.env.REACT_APP_ONE_SIGNAL_ID || "215cec35-5eb2-4269-96ef-a2fb3a1958c6",
      autoResubscribe: true,
      autoRegister: true,
      // O SDK recusa inicializar em http://localhost sem isto, e então nenhum
      // navegador chega a se inscrever. Em produção o site é HTTPS e a opção
      // não tem razão de existir.
      allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== "production",
    },
  },
}
